'use client';

import { useEffect, useRef, useState } from 'react';

interface BreakPoints {
    md?: number;
    lg?: number;
    xl?: number;
}

interface IconAdaptiveProps {
    Icon: React.ElementType;
    baseSize: number;
    breakpoints?: BreakPoints;
    strokeWidth?: number;
    fill?: string;
    className?: string;
    onClick?: () => void;
}

export default function IconAdaptive({
    Icon,
    baseSize,
    breakpoints = {},
    strokeWidth = 2,
    fill,
    className = '',
    onClick,
}: IconAdaptiveProps) {
    const [currentSize, setCurrentSize] = useState<number | null>(null);
    const breakpointsRef = useRef(breakpoints);
    const baseSizeRef = useRef(baseSize);

    useEffect(() => {
        breakpointsRef.current = breakpoints;
        baseSizeRef.current = baseSize;
    });

    useEffect(() => {
        const updateSize = () => {
            const width = window.innerWidth;
            const bp = breakpointsRef.current;
            const base = baseSizeRef.current;
            if (width >= 1280 && bp.xl) {
                setCurrentSize(bp.xl);
            } else if (width >= 1024 && bp.lg) {
                setCurrentSize(bp.lg);
            } else if (width >= 768 && bp.md) {
                setCurrentSize(bp.md);
            } else {
                setCurrentSize(base);
            }
        };

        updateSize();
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, []); // 依存配列を空に

    if (currentSize === null) return null;

    return (
        <Icon
            onClick={onClick}
            strokeWidth={strokeWidth}
            fill={fill ?? 'none'}
            className={`flex-shrink-0 ${className}`}
            style={{
                width: currentSize,
                height: currentSize,
            }}
        />
    );
}
